import React from "react";
import Loading from "../Loading/Loading";

interface IGvPaymentLoader {
  message?: string;
}

const CentralLoadingIndicator = ({ message="" } : IGvPaymentLoader) =>{
  return (
    <div className="w-full h-full flex flex-col justify-center items-center">
      <Loading />
      <div className="text-center">{message}</div>
    </div>
  );
};

export default CentralLoadingIndicator;
